<h3>
  <label>Geopal Reports</label>
  <ng-container style="display:inline-block">
    <button (click)="exportInstallationsCSV()" id="export_button">Export as .csv</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <span>Count: {{rowCount}}</span>
  </ng-container>
</h3>
<div>
  <!--ng-container *ngIf="loading; then Loading; else Loaded"></ng-container-->
  <ng-container *ngIf="true; then Table"></ng-container>
</div>

<ng-template #Table>
  <reports #child (rowCountEvent)="receiveCount($event)"></reports>
</ng-template>